import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";

export const MainImage = (props) => {
    const modelCtx = useContext(ModelContext);
    const [image, setImage] = useState({
        filE_NAME: "",
        flaG_FG: false,
        flaG_FGA: false,
        fullpatH_FILE_NAME: "",
        layouT_GROUP_ID: 0,
        layouT_GROUP_LANGUAGES_DESCRIPTION: "",
        mediA_CONTENT_SORTING: 0,
        tags: "",
        tagS_DESCRIPTION: "",
        templateS_DESCRIPTION: "",
        updatE_DATE: "",
        url: ""
    });

    useEffect(() => {
        const getMainImage = async () => {
            const input = modelCtx.inputModelData;
            if (input.idBasicModel !== 0) {

                const response = await fetch("/api/model/mainimage", {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        setImage(data);
                    }
                } else {
                    // Error
                }
            }
        }
        getMainImage();
    }, [modelCtx.inputModelData]);


    return (
        <>
            <div>
                <img style={{ maxWidth: "100%" }}
                    src={image.fullpatH_FILE_NAME}
                    alt={image.tagS_DESCRIPTION}
                />
            </div>
            <div className="row pb-5">
                <div className="clear"></div>
            </div>
        </>
    );
};

export default MainImage;
